export const clearAccessoriesSummaryForRelatedProducts = ({ serialNumber }) => {
    const accessoriesSummary = document.querySelector('.configurator_info-accessories');

   if (!accessoriesSummary == null) 
     [...accessoriesSummary?.children]?.forEach(aSc => {
       if(!aSc.id.includes(serialNumber)) {
         accessoriesSummary.removeChild(aSc);
        }
     });
}